import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const create = ({
    firstName,
    lastName,
    email,
    studentId,
    gradYear,
    rolesCode,
}) => {
    return axios.post(urlGenerator.users(), {
        firstName,
        lastName,
        email,
        studentId,
        gradYear,
        rolesCode,
    }, createRequestConfig()).then(property('data'))
}

const update = ({
    id,
    firstName,
    lastName,
    studentId,
    gradYear,
    rolesCode,
}) => {
    return axios.put(urlGenerator.user(id), {
        firstName,
        lastName,
        studentId,
        gradYear,
        rolesCode,
    }, createRequestConfig()).then(property('data'))
}

export default {
    create,
    update,
}